import { webAudioContext } from "./webaudio_context";
import { webAudioUtils } from "./webaudio_utils";
import { NodeHtml } from "./node_html";

class NodeGain extends NodeHtml {
  handlers = this.extendParentHandlers({
    volume: { handler: this.setVolume, type: "float", default: 0, min: -80, max: 12 },
  });

  setProps(dnode) {
    dnode.input = webAudioContext.context.createGain();
    dnode.output = dnode.input;
    dnode.output.gain.value = webAudioUtils.dbToJs(dnode.props.volume);
    dnode.sources = new Map();
    super.setProps(dnode);
  }

  setVolume(dnode) {
    dnode.output.gain.value = webAudioUtils.dbToJs(dnode.props.volume);
  }
}

const nodeGain = new NodeGain("webaudio:node:gain");
export { nodeGain, NodeGain };
